import React from 'react';
import PropTypes from 'prop-types';
import {
  modalDisplayDataShape,
  formDataShape,
} from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import {
  WorkInformationItemSummary,
  WORK_INFORMATION_ITEM_SUMMARY,
} from './work-information-item-summary';
import {
  RelationshipsSummary,
  RELATIONSHIPS_SUMMARY,
} from './relationships-summary';
import {
  CiUnavailabilitySummary,
  CI_UNAVAILABILITY_SUMMARY,
} from './ci-unavailability-summary';


const modalSummaryMap = {
  [WORK_INFORMATION_ITEM_SUMMARY]: WorkInformationItemSummary,
  [RELATIONSHIPS_SUMMARY]: RelationshipsSummary,
  [CI_UNAVAILABILITY_SUMMARY]: CiUnavailabilitySummary,
};

const getModalSummaryComponent = (modalSummaryType) => {
  const ModalSummaryComponent = modalSummaryMap[modalSummaryType];

  if (!ModalSummaryComponent) {
    console.warn(`Cannot find modal summary component for ${modalSummaryType}`);
    return () => null;
  }

  return ModalSummaryComponent;
};


const ModalSummary = ({
  modalSummaryType,
  displayType,
  modalData,
  editItem,
  deleteItem,
  selectedNetwork,
  formData,
  readOnly,
}) => {

  const ModalSummaryComponent = getModalSummaryComponent(modalSummaryType);

  return (
    <ModalSummaryComponent
      displayType={displayType}
      modalData={modalData}
      editItem={editItem}
      deleteItem={deleteItem}
      selectedNetwork={selectedNetwork}
      formData={formData}
      readOnly={readOnly}
    />
  );
};

ModalSummary.propTypes = {
  modalSummaryType: PropTypes.string,
  displayType: PropTypes.string,
  modalData: modalDisplayDataShape,
  editItem: PropTypes.func,
  deleteItem: PropTypes.func,
  selectedNetwork: PropTypes.string,
  formData: formDataShape,
  readOnly: PropTypes.bool,
};


export {
  ModalSummary,
};
